module.exports = __webpack_public_path__ + "img/logo.e7fcf578.jpg";